import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#1590FF",
        d: "M42 24.0191c0-9.9305-8.0589-17.9808-18-17.9808S6 14.0886 6 24.019C6 33.9497 14.0589 42 24 42s18-8.0503 18-17.9809"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#035384",
        d: "M6.1215 21.9421c1.128-9.8475 10.1032-16.9514 19.9612-15.8246l-2.3051 17.7843z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#065A8E",
        d: "M26.0338 6.167c9.858 1.1268 16.9695 10.0434 15.7924 19.8909l-18.0484-2.1556z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#0979CC",
        d: "M34.6657 9.5957c7.9943 5.9281 9.6618 17.1474 3.7274 25.1332L23.7778 23.9015z"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#095289",
        d: "M23.8271 23.9017H6.0239s0-1.9107.4414-3.8705z"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#01395B",
        d: "m22.6991 35.9052-1.3732-2.7926h-.5395v2.7926H19.266v-6.957h2.4522c.2943 0 .5886.049.8828.098s.5395.196.7847.343c.2453.1469.4414.3919.5395.6369.1472.2449.1962.5879.1962 1.0288 0 .4899-.0981.8819-.3433 1.1758-.2452.294-.5395.5389-.9809.6859l1.6675 2.9886zm-.049-4.8503c0-.147-.0491-.2939-.0981-.3919s-.1471-.196-.2452-.245-.1962-.098-.3433-.098c-.1472 0-.2453-.049-.3434-.049h-.8337v1.6168h.7356c.1472 0 .2453 0 .3924-.049.1471 0 .2452-.049.3433-.147.0981-.049.1962-.147.2452-.245.0981-.0979.1472-.2449.1472-.3919"
    }, "5")
], "AppReports", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
